const InvestorComplaintSection = () => {
  return (
    <section className="about about--style1 bg-color xts-section">
      <div className="container">
        <div className="about__wrapper">
          <div className="row gx-5 gy-4 gy-sm-0 align-items-center">
            <div className="col-lg-12 mt-30">
              <div className="about__content">
                <div className="about__content-inner">
                  <h3
                    className="mt-4 text-center aos-init aos-animate"
                    data-aos="fade-down"
                    data-aos-duration="500"
                  >
                    {" "}
                    EQUITY{" "}
                  </h3>
                  <h6>Data for the month ending Sep-2026</h6>
                  <table className="comparison-table">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Received from</th>
                        <th>Carried forward from prev. month</th>
                        <th>Received during the month</th>
                        <th>Total pending</th>
                        <th>Resolved *</th>
                        <th colspan="2">Pending at the end of the month **</th>
                        <th>Average resolution time ^ (in days)</th>
                      </tr>
                      <tr>
                        <th style={{background: "rgb(248, 249, 250)", border: "1px solid rgb(234, 234, 234)"}}></th>
                        <th style={{background: "rgb(248, 249, 250)", border: "1px solid rgb(234, 234, 234)"}}></th>
                        <th style={{background: "rgb(248, 249, 250)", border: "1px solid rgb(234, 234, 234)"}}></th>
                        <th style={{background: "rgb(248, 249, 250)", border: "1px solid rgb(234, 234, 234)"}}></th>
                        <th style={{background: "rgb(248, 249, 250)", border: "1px solid rgb(234, 234, 234)"}}></th>
                        <th style={{background: "rgb(248, 249, 250)", border: "1px solid rgb(234, 234, 234)"}}></th>
                        <th>Pending for less than 3 months</th>
                        <th>Pending for more than 3 months</th>
                        <th style={{background: "rgb(248, 249, 250)", border: "1px solid rgb(234, 234, 234)"}}></th>
                      </tr>
                    </thead>
                    <tbody style={{textAlign: "center"}}>
                      <tr style={{background: "rgb(190, 225, 255)"}}>
                        <td>
                          <b>1</b>
                        </td>
                        <td>
                          <b>2</b>
                        </td>
                        <td>
                          <b>3</b>
                        </td>
                        <td>
                          <b>4</b>
                        </td>
                        <td>
                          <b>5</b>
                        </td>
                        <td>
                          <b>6</b>
                        </td>
                        <td colspan="2">
                          <b>7</b>
                        </td>
                        <td>
                          <b>8</b>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <b>1</b>
                        </td>
                        <td>Directly from investors</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td colspan="2">N/A</td>
                        <td>N/A</td>
                        <td>N/A</td>
                      </tr>
                      <tr>
                        <td>
                          <b>2</b>
                        </td>
                        <td>SEBI(SCORES 2.0 )</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td colspan="2">N/A</td>
                        <td>N/A</td>
                        <td>N/A</td>
                      </tr>
                      <tr>
                        <td>
                          <b>3</b>
                        </td>
                        <td>Stock Exchanges</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td colspan="2">N/A</td>
                        <td>N/A</td>
                        <td>N/A</td>
                      </tr>
                      <tr>
                        <td>
                          <b>4</b>
                        </td>
                        <td>Othersources (if any)</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td colspan="2">N/A</td>
                        <td>N/A</td>
                        <td>N/A</td>
                      </tr>
                      <tr>
                        <td>
                          <b>5</b>
                        </td>
                        <td>
                          <b>Grand Total</b>
                        </td>
                        <td>
                          <b>0</b>
                        </td>
                        <td>
                          <b>0</b>
                        </td>
                        <td>
                          <b>0</b>
                        </td>
                        <td colspan="2">
                          <b>N/A</b>
                        </td>
                        <td>
                          <b>N/A</b>
                        </td>
                        <td>
                          <b>N/A</b>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <h6>Trend of monthly disposal of complaints</h6>
                  <table className="comparison-table">
                    <thead>
                      <tr>
                        <th>Sr. No</th>
                        <th>Month</th>
                        <th>Carried forward from prev. month</th>
                        <th>Received</th>
                        <th>Resolved*</th>
                        <th>Pending**</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr style={{background: "rgb(190, 225, 255)"}}>
                        <td>
                          <b>1</b>
                        </td>
                        <td>
                          <b>2</b>
                        </td>
                        <td>
                          <b>3</b>
                        </td>
                        <td>
                          <b>4</b>
                        </td>
                        <td>
                          <b>5</b>
                        </td>
                        <td>
                          <b>6</b>
                        </td>
                      </tr>
                      
                      <tr>
                        <td>
                          <b>1</b>
                        </td>
                        <td>Oct-2025</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b>2</b>
                        </td>
                        <td>Nov-2025</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b>3</b>
                        </td>
                        <td>Dec-2025</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b>4</b>
                        </td>
                        <td>Jan-2026</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b>5</b>
                        </td>
                        <td>Feb-2026</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b>6</b>
                        </td>
                        <td>March-2026</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b>7</b>
                        </td>
                        <td>April-2026</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b>8</b>
                        </td>
                        <td>May-2026</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b>9</b>
                        </td>
                        <td>June-2026</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b>10</b>
                        </td>
                        <td>July-2026</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b>11</b>
                        </td>
                        <td>Aug-2026</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                       <tr>
                        <td>
                          <b>12</b>
                        </td>
                        <td>Sep-2026</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>

                      <tr>
                        <td>
                          <b></b>
                        </td>
                        <td>
                          <b>Grand Total</b>
                        </td>
                        <td>
                          <b>0</b>
                        </td>
                        <td>
                          <b>0</b>
                        </td>
                        <td>
                          <b>0</b>
                        </td>
                        <td>
                          <b>0</b>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <h6>Trend of annual disposal of complaints</h6>
                  <table className="comparison-table">
                    <thead>
                      <tr>
                        <th>Sr. No</th>
                        <th>Year</th>
                        <th>Carried forward from prev. year</th>
                        <th>Received during the year</th>
                        <th>Resolved during the year*</th>
                        <th>Pending at the end of the year**</th>
                      </tr>
                    </thead>
                    <tbody style={{textAlign: "center"}}>
                      <tr style={{background: "rgb(190, 225, 255)"}}>
                        <td>
                          <b>1</b>
                        </td>
                        <td>
                          <b>2</b>
                        </td>
                        <td>
                          <b>3</b>
                        </td>
                        <td>
                          <b>4</b>
                        </td>
                        <td>
                          <b>5</b>
                        </td>
                        <td>
                          <b>6</b>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <b>1</b>
                        </td>
                        <td>2021-22</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b>2</b>
                        </td>
                        <td>2022-23</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b>3</b>
                        </td>
                        <td>2023-24</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b>4</b>
                        </td>
                        <td>2024-25</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b>5</b>
                        </td>
                        <td>2025-26</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b>6</b>
                        </td>
                        <td>2026-27</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b></b>
                        </td>
                        <td>
                          <b>Grand Total</b>
                        </td>
                        <td>
                          <b>0</b>
                        </td>
                        <td>
                          <b>0</b>
                        </td>
                        <td>
                          <b>0</b>
                        </td>
                        <td>
                          <b>0</b>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <h3
                    className="mt-4 text-center aos-init"
                    data-aos="fade-down"
                    data-aos-duration="500"
                  >
                    {" "}
                    Futures &amp; Options{" "}
                  </h3>
                  <h6>Data for the month ending Sep-2026 </h6>
                  <table className="comparison-table">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Received from</th>
                        <th>Carried forward from prev. month</th>
                        <th>Received during the month</th>
                        <th>Total pending</th>
                        <th>Resolved *</th>
                        <th colspan="2">Pending at the end of the month **</th>
                        <th>Average resolution time ^ (in days)</th>
                      </tr>
                      <tr>
                        <th style={{background: "rgb(248, 249, 250)", border: "1px solid rgb(234, 234, 234)"}}></th>
                        <th style={{background: "rgb(248, 249, 250)", border: "1px solid rgb(234, 234, 234)"}}></th>
                        <th style={{background: "rgb(248, 249, 250)", border: "1px solid rgb(234, 234, 234)"}}></th>
                        <th style={{background: "rgb(248, 249, 250)", border: "1px solid rgb(234, 234, 234)"}}></th>
                        <th style={{background: "rgb(248, 249, 250)", border: "1px solid rgb(234, 234, 234)"}}></th>
                        <th style={{background: "rgb(248, 249, 250)", border: "1px solid rgb(234, 234, 234)"}}></th>
                        <th>Pending for less than 3 months</th>
                        <th>Pending for more than 3 months</th>
                        <th style={{background: "rgb(248, 249, 250)", border: "1px solid rgb(234, 234, 234)"}}></th>
                      </tr>
                    </thead>
                    <tbody style={{textAlign: "center"}}>
                      <tr style={{background: "rgb(190, 225, 255)"}}>
                        <td>
                          <b>1</b>
                        </td>
                        <td>
                          <b>2</b>
                        </td>
                        <td>
                          <b>3</b>
                        </td>
                        <td>
                          <b>4</b>
                        </td>
                        <td>
                          <b>5</b>
                        </td>
                        <td>
                          <b>6</b>
                        </td>
                        <td colspan="2">
                          <b>7</b>
                        </td>
                        <td>
                          <b>8</b>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <b>1</b>
                        </td>
                        <td>Directly from investors</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td colspan="2">N/A</td>
                        <td>N/A</td>
                        <td>N/A</td>
                      </tr>
                      <tr>
                        <td>
                          <b>2</b>
                        </td>
                        <td>SEBI(SCORES 2.0 )</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td colspan="2">N/A</td>
                        <td>N/A</td>
                        <td>N/A</td>
                      </tr>
                      <tr>
                        <td>
                          <b>3</b>
                        </td>
                        <td>Stock Exchanges</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td colspan="2">N/A</td>
                        <td>N/A</td>
                        <td>N/A</td>
                      </tr>
                      <tr>
                        <td>
                          <b>4</b>
                        </td>
                        <td>Othersources (if any)</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td colspan="2">N/A</td>
                        <td>N/A</td>
                        <td>N/A</td>
                      </tr>
                      <tr>
                        <td>
                          <b>5</b>
                        </td>
                        <td>
                          <b>Grand Total</b>
                        </td>
                        <td>
                          <b>0</b>
                        </td>
                        <td>
                          <b>0</b>
                        </td>
                        <td>
                          <b>0</b>
                        </td>
                        <td colspan="2">
                          <b>N/A</b>
                        </td>
                        <td>
                          <b>N/A</b>
                        </td>
                        <td>
                          <b>N/A</b>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <h6>Trend of monthly disposal of complaints</h6>
                  <table className="comparison-table">
                    <thead>
                      <tr>
                        <th>Sr. No</th>
                        <th>Month</th>
                        <th>Carried forward from prev. month</th>
                        <th>Received</th>
                        <th>Resolved*</th>
                        <th>Pending**</th>
                      </tr>
                    </thead>
                    <tbody style={{textAlign: "center"}}>
                      <tr style={{background: "rgb(190, 225, 255)"}}>
                        <td>
                          <b>1</b>
                        </td>
                        <td>
                          <b>2</b>
                        </td>
                        <td>
                          <b>3</b>
                        </td>
                        <td>
                          <b>4</b>
                        </td>
                        <td>
                          <b>5</b>
                        </td>
                        <td>
                          <b>6</b>
                        </td>
                      </tr>
                     
                      <tr>
                        <td>
                          <b>1</b>
                        </td>
                        <td>Oct-2025</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b>2</b>
                        </td>
                        <td>Nov-2025</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b>3</b>
                        </td>
                        <td>Dec-2025</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b>4</b>
                        </td>
                        <td>Jan-2026</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b>5</b>
                        </td>
                        <td>Feb-2026</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b>6</b>
                        </td>
                        <td>March-2026</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b>7</b>
                        </td>
                        <td>April-2026</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b>8</b>
                        </td>
                        <td>May-2026</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b>9</b>
                        </td>
                        <td>June-2026</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b>10</b>
                        </td>
                        <td>July-2026</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b>11</b>
                        </td>
                        <td>Aug-2026</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                       <tr>
                        <td>
                          <b>12</b>
                        </td>
                        <td>Sep-2026</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b></b>
                        </td>
                        <td>
                          <b>Grand Total</b>
                        </td>
                        <td>
                          <b>0</b>
                        </td>
                        <td>
                          <b>0</b>
                        </td>
                        <td>
                          <b>0</b>
                        </td>
                        <td>
                          <b>0</b>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <h6>Trend of annual disposal of complaints</h6>
                  <table className="comparison-table">
                    <thead>
                      <tr>
                        <th>Sr. No</th>
                        <th>Year</th>
                        <th>Carried forward from prev. year</th>
                        <th>Received during the year</th>
                        <th>Resolved during the year*</th>
                        <th>Pending at the end of the year**</th>
                      </tr>
                    </thead>
                    <tbody style={{textAlign: "center"}}>
                      <tr style={{background: "rgb(190, 225, 255)"}}>
                        <td>
                          <b>1</b>
                        </td>
                        <td>
                          <b>2</b>
                        </td>
                        <td>
                          <b>3</b>
                        </td>
                        <td>
                          <b>4</b>
                        </td>
                        <td>
                          <b>5</b>
                        </td>
                        <td>
                          <b>6</b>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <b>1</b>
                        </td>
                        <td>2021-22</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b>2</b>
                        </td>
                        <td>2022-23</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b>3</b>
                        </td>
                        <td>2023-24</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b>4</b>
                        </td>
                        <td>2024-25</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b>5</b>
                        </td>
                        <td>2025-26</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b>6</b>
                        </td>
                        <td>2026-27</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                        <td>0</td>
                      </tr>
                      <tr>
                        <td>
                          <b></b>
                        </td>
                        <td>
                          <b>Grand Total</b>
                        </td>
                        <td>
                          <b>0</b>
                        </td>
                        <td>
                          <b>0</b>
                        </td>
                        <td>
                          <b>0</b>
                        </td>
                        <td>
                          <b>0</b>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InvestorComplaintSection;
